import React, {useEffect, useState} from 'react'
import {FieldValues, UseFormRegister} from 'react-hook-form'

interface FormTextAreaProps {
  label?: string
  required?: boolean
  value?: string
  onChange?: (value?: string) => void
  placeholder?: string
  error?: string
  name: string
  register?: UseFormRegister<FieldValues>
}
export const FormTextArea = ({
  label,
  required,
  onChange,
  placeholder,
  error,
  name,
  value: defaultValue,
  register,
}: FormTextAreaProps) => {
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <div className='input-container'>
      {label && (
        <p>
          {label}
          {required && <span>*</span>}
        </p>
      )}
      <textarea
        required={required}
        name={name}
        placeholder={placeholder}
        value={value}
        rows={4}
        onChange={(e) => {
          setValue(e.target.value)
          onChange?.(e.target.value)
        }}
        {...register?.(name)}
      />
      {error && <p className='error'>{error}</p>}
    </div>
  )
}
